<template>
  <v-icon small color="error" :title="title">{{ icon }}</v-icon>
</template>

<script>
export default {
  props: ["documento"],
  computed: {
    title() {
      if (this.documento.novo) {
        return "Novo";
      }
      if (this.documento.remover) {
        return "Marcado para remoção";
      }
      if (this.documento.editar) {
        return "Editado";
      }
      return "";
    },
    icon() {
      if (this.documento.novo) {
        return "mdi-new-box";
      }
      if (this.documento.remover) {
        return "mdi-delete-outline";
      }
      if (this.documento.editar) {
        return "mdi-pencil-outline";
      }
      return "";
    },
  },
};
</script>
